import {
  EDITOR_SAVE_REQUESTED,
  EDITOR_SAVE_FAILURE,
  EDITOR_SAVE_SUCCESS,
  SET_ACTIVE_EDITOR,
  SET_READ_ONLY,
  SET_EDITOR_TYPE,
  CONTENT_OUT_OF_DATE,
  DIFFERENT_TAB_LOCKED,
} from "editor/actions/status";

import { GET_ITEM_SUCCEEDED } from "actions/items";

import {
  APPEND_NEWSLETTER_CHUNK,
  MOVE_NEWSLETTER_CHUNK_UP,
  MOVE_NEWSLETTER_CHUNK_DOWN,
  DELETE_NEWSLETTER_CHUNK,
} from "editor/actions/newsletter";

import {
  LOCK_ITEM_SUCCEEDED,
  UNLOCK_ITEM_SUCCEEDED,
  CHECK_ITEM_LOCK_SUCCEEDED,
  RESET_LOCK_STATE,
  SET_EDIT_KEY,
} from "editor/actions/locking";

import { UPDATE_FORM, UPDATE_FORM_AT } from "editor/actions/form";

const initialState = {
  isDirty: false,
  isSaving: false,
  isReadOnly: false,
  contentOutOfDate: false,
  differentTabLocked: false,
  activeEditor: {
    name: "content", // This needs a default value for the Toolbar to show up.
    isInline: false,
  },
  editorType: {
    name: "content",
  },
  lock: null,
  editKey: null,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_ACTIVE_EDITOR:
      return {
        ...state,
        activeEditor: action.payload,
      };

    case SET_EDITOR_TYPE:
      return {
        ...state,
        editorType: action.payload,
      };

    case SET_READ_ONLY:
      return {
        ...state,
        isReadOnly: action.payload,
      };

    case UPDATE_FORM:
    case UPDATE_FORM_AT:
      return {
        ...state,
        isDirty: true,
      };

    case APPEND_NEWSLETTER_CHUNK:
    case MOVE_NEWSLETTER_CHUNK_UP:
    case MOVE_NEWSLETTER_CHUNK_DOWN:
    case DELETE_NEWSLETTER_CHUNK:
      // We cannot guarantee the existence of the activeEditor key if we mess with the newsletter chunks so reset activeEditor.
      return {
        ...state,
        isDirty: true,
        activeEditor: { name: "intro", isInline: false },
      };

    case EDITOR_SAVE_REQUESTED:
      return {
        ...state,
        isSaving: true,
      };

    case EDITOR_SAVE_SUCCESS:
      return {
        ...state,
        isSaving: false,
        isDirty: false,
      };

    case EDITOR_SAVE_FAILURE:
      return {
        ...state,
        isSaving: false,
      };

    case GET_ITEM_SUCCEEDED:
      return {
        ...state,
        lock: action.payload.lock,
        isReadOnly:
          state.contentOutOfDate ||
          state.differentTabLocked ||
          (action.payload.lock === null
            ? true
            : !action.payload.lock.locked_by_this_session),
      };

    case CHECK_ITEM_LOCK_SUCCEEDED:
      return {
        ...state,
        lock: action.payload,
        isReadOnly:
          state.contentOutOfDate ||
          state.differentTabLocked ||
          !action.payload.locked_by_this_session,
      };

    case LOCK_ITEM_SUCCEEDED:
      return {
        ...state,
        lock: action.payload.lock,
        isReadOnly: !action.payload.lock.locked_by_this_session,
        differentTabLocked: false,
      };

    case UNLOCK_ITEM_SUCCEEDED:
    case RESET_LOCK_STATE:
      return {
        ...state,
        lock: null,
        editKey: null,
        isReadOnly: false,
        contentOutOfDate: false,
        differentTabLocked: false,
      };

    case CONTENT_OUT_OF_DATE:
      return {
        ...state,
        contentOutOfDate: true,
      };

    case SET_EDIT_KEY:
      return {
        ...state,
        editKey: action.payload,
      };

    case DIFFERENT_TAB_LOCKED:
      return {
        ...state,
        differentTabLocked: true,
        isReadOnly: true,
      };

    default:
      return state;
  }
}
